import { TypographySelectValue } from '@makyoapp/makyo-common'

type MarginUnitValue = [number, number?, number?, number?]
type MarginUnit = 'px' | 'rem' | 'em' | '%' | 'vh' | 'vw'

/**
 * Provide the margin value based on CSS shordhand rules.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin#syntax:}
 *
 * @default
 *  - 1 value  -> all sides
 *  - 2 values -> vertical (top/bottom) | horizontal (left/right)
 *  - 3 values -> top | horizontal (left/right) | bottom
 *  - 4 values -> top | right | bottom | left
 *
 */
export function getDefaultMargin(values: MarginUnitValue = [8, 16], unit: MarginUnit = 'px') {
  // Handle different array lengths according to CSS shorthand rules
  const [first, second, third, fourth] = values

  const top = first
  const right = second !== undefined ? second : first
  const bottom = third !== undefined ? third : first
  const left = fourth !== undefined ? fourth : second !== undefined ? second : first

  return {
    top: { value: top, unit },
    right: { value: right, unit },
    bottom: { value: bottom, unit },
    left: { value: left, unit },
  }
}

export function getDefaultTypography(style: string): TypographySelectValue {
  return {
    typography: style,
  }
}

export const getDefaultMarginOverlay = {
  phone: getDefaultMargin([5, 0, 5, 0]),
  'phone-landscape': getDefaultMargin([5, 0, 5, 0]),
  tablet: getDefaultMargin([5, 0, 5, 0]),
  'tablet-landscape': getDefaultMargin([5, 0, 5, 0]),
  desktop: getDefaultMargin([5, 0, 5, 0]),
  tv: getDefaultMargin([5, 0, 5, 0]),
}

export const getDefaultLineOverlay = {
  phone: [4],
  'phone-landscape': [4],
  tablet: [4],
  'tablet-landscape': [4],
  desktop: [4],
  tv: [4],
}

export const getDefaultWidthOverlay = {
  phone: ['100%'],
  'phone-landscape': ['100%'],
  tablet: ['100%'],
  'tablet-landscape': ['100%'],
  desktop: ['100%'],
  tv: ['100%'],
}
